/// <amd-module name="Artifacts/Feed/redux/Contracts" />

import { IArtifactsSettingsData } from "Artifacts/Feed/services/ArtifactsSettingsService";
import { ProblemPackageItem } from "Artifacts/Feed/types/ProblemPackageItem";
import { ComponentState } from "Artifacts/Root/constants";
import { CreateFeedAdditionalData, PackageListDataItem } from "Artifacts/Root/types/AzureArtifacts";

export interface IFeedHubState {
  packageListComponentState: ComponentState;
  problemPackageListComponentState: ComponentState;
  packageData?: PackageListDataItem[];
  problemPackageData?: ProblemPackageItem[];
}

export interface ICreateFeedPanelState {
  componentState: ComponentState;
  serviceParams?: CreateFeedAdditionalData;
  createButtonComponentState: ComponentState;
}

export interface IArtifactsSettingsPanelState {
  componentState: ComponentState;
  saveButtonComponentState: ComponentState;
  serviceParams?: IArtifactsSettingsData;
}
